import { createSlice } from "@reduxjs/toolkit";
import { getCompanyProfile, getBranch, editCompany } from "API/CompanyAPI";
// import { getLogin } from "../../API/AuthAPI";

const initialState = {
  Company: [],
  Branch: [],
  Edit: [],
  loading: false,
};

export const CompanySlice = createSlice({
  name: "UserState",

  initialState,
  reducers: {
    updateGetCompanyProfile: (state, action) => {
      state.Company = action.payload;
    },
    updateGetBranch: (state, action) => {
      state.Branch = action.payload;
    },
    updateEditCompany: (state, action) => {
      state.Edit = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setLoading } = CompanySlice.actions;
export const { updateGetCompanyProfile } = CompanySlice.actions;
export const getCompanyProfiledetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await getCompanyProfile(value);
    dispatch(updateGetCompanyProfile(data));

    dispatch(setLoading(false));
  } catch (error) {
    console.error(error);
    dispatch(setLoading(false));
  }
};

export const { updateGetBranch } = CompanySlice.actions;
export const getBranchdetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await getBranch(value);
    dispatch(updateGetBranch(data));

    dispatch(setLoading(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoading(false));
  }
};

export const { updateEditCompany } = CompanySlice.actions;
export const editCompanydetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await editCompany(value);
    dispatch(updateEditCompany(data));

    dispatch(setLoading(false));
  } catch (error) {
    console.error(error);
    dispatch(setLoading(false));
  }
};

export default CompanySlice.reducer;
